import Vue from 'vue'
import VueRouter from 'vue-router'
import { authService } from '@/services/auth'
import { setUnauthorizedHandler } from '@/services/api'
import { clearProfile } from '@/store/user'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { auth: true },
    children: [
      { path: '', name: 'overview', component: () => import('@/views/challenge/OverviewView.vue') },
      { path: 'leaderboard', name: 'leaderboard', component: () => import('@/views/challenge/LeaderboardView.vue') },
      { path: 'route', name: 'route', component: () => import('@/views/challenge/RouteView.vue') },
      { path: 'accounts', name: 'accounts', component: () => import('@/views/accounts/AccountsView.vue') },
      { path: 'accounts/transfer', name: 'accounts-transfer', component: () => import('@/views/accounts/TransferView.vue') },
      { path: 'accounts/records', name: 'accounts-records', component: () => import('@/views/accounts/TransferRecordsView.vue') },
      { path: 'news', name: 'news', component: () => import('@/views/news/NewsListView.vue') },
      { path: 'news/:id', name: 'news-detail', component: () => import('@/views/news/NewsDetailView.vue') },
      { path: 'profile', name: 'profile', component: () => import('@/views/member/ProfileView.vue') }
    ]
  },
  // Auth layout is listed second so '/' resolves to the overview child above.
  {
    path: '/',
    component: () => import('@/layouts/AuthLayout.vue'),
    meta: { guest: true },
    children: [
      { path: 'login', name: 'login', component: () => import('@/views/auth/LoginView.vue') },
      { path: 'register', name: 'register', component: () => import('@/views/auth/RegisterView.vue') }
    ]
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  // Not BASE_URL: in production that is the asset path (/assets/web/), while pages are served from the root.
  base: '/',
  routes,
  scrollBehavior: () => ({ x: 0, y: 0 })
})

router.beforeEach((to, from, next) => {
  const loggedIn = authService.isAuthenticated()
  if (to.matched.some(r => r.meta.auth) && !loggedIn) {
    return next({ name: 'login', query: to.fullPath !== '/' ? { redirect: to.fullPath } : {} })
  }
  if (to.matched.some(r => r.meta.guest) && loggedIn) {
    return next('/')
  }
  next()
})

setUnauthorizedHandler(() => {
  clearProfile()
  const current = router.currentRoute
  if (current.name !== 'login') {
    router.replace({ name: 'login', query: { redirect: current.fullPath } }).catch(() => {})
  }
})

export default router
